import { useEffect, useState } from "react";
import { Helmet } from "fusion-plugin-react-helmet-async";
import { assetUrl } from "fusion-core";
import Navbar from "../../../../shared/components/navbar";
import Footer from "../../../../shared/components/footer";
import AllSupportSteps from "./allSupportSteps";
import { useSearchParams } from "react-router-dom";
import CancellationDisclaimer from "../../components/support/CancellationDisclaimer";
import ChangeDisclaimer from "../../components/support/ChangeDisclaimer";
import SupportStep from "../../enums/SupportStep";
import useAppStateStore from "../../../../shared/store/AppStateStore";
import Loader from "../../../../shared/components/Loader";

const mainCss = assetUrl("../../../../styles/support.css");

const Support = () => {
  const [searchParams] = useSearchParams();
  const supportType = searchParams.get("supportType");
  const STATE = useAppStateStore();

  useEffect(() => {
    if (supportType === "cancelPolicy") {
      STATE.setSelectedOptions([
        { id: SupportStep.SP_CANCELLATION, title: "Cancellation" },
      ]);
      STATE.setSpCurrentStep(SupportStep.SP_CANCELLATION);
    }
  }, []);

  return (
    <>
      {STATE.supportLoading && <Loader text={"In progress..."} />}
      <Navbar />
      <div className="mainBody">
        <Helmet>
          <link rel="stylesheet" href={mainCss} />
        </Helmet>
        <AllSupportSteps />
        {STATE.isCancellationModalOpen && <CancellationDisclaimer />}
        {STATE.isChangeModalOpen && <ChangeDisclaimer />}
      </div>
      <Footer />
    </>
  );
};

export default Support;
